export enum SceneToken {
  OPEN = -1,
  START_PAGE,
  QUESTION,
  SIGN_UP,
  FORM,
  RESULT,
  FINAL,
  SELECTION
}